<template>
  <main id="help-dashboard" class="site-main">
    <div class="grid-x grid-padding-x">
      <div class="cell">
        <div class="panel">
          <div class="panel__header">
            <h2 class="panel__title">Support</h2>
          </div>

          <div class="panel__content">
            <p>We usually respond within 24 hours on business days.</p>
            <div>Hours: M-F 8:00am-4:00pm Pacific Time</div>
            <p><i>Our team will be unavailable December 23-26 and December
              30-January 2 this holiday season.</i></p>
            <p>You can refer to our knowledge base for helpful tutorials and
              answers to commonly asked questions.
              <a href="https://visceralapps.zohodesk.com/portal/en/kb/visceral-apps" target="_blank">Knowledge Base</a></p>
            <a href="mailto:support@visceralapps.zohodesk.com">support@visceralapps.zohodesk.com</a>
            <!-- <iframe id="zsfeedbackFrame" width="890" height="570" name="zsfeedbackFrame" scrolling="no" allowtransparency="false" frameborder="0" border="0" src="https://desk.zoho.com/support/fbw?formType=AdvancedWebForm&fbwId=edbsnb7db3550507b0fc95f1b3653bd8fcbe5ee726aa5a83c2a68f25b8eae645273ec&xnQsjsdp=edbsn9dea2b51929b3c5e84eac97a85afebc7&mode=showNewWidget&displayType=iframe"></iframe> -->
          </div>
        </div>

        <div class="grid-x grid-padding-x">
          <div class="cell large-5">
            <div class="panel">
              <div class="panel__header">
                <h2 class="panel__title">Tutorials</h2>
              </div>

              <div class="panel__content">
                <ul class="tutorials">
                  <li class="tutorials__item">
                    <router-link to="/help/setting-up-vendors">Setting Up Vendors
                      <i class="fas fa-angle-right"></i></router-link>
                  </li>

                  <!--                  <li class="tutorials__item">-->
                  <!--                    <router-link to="/help/connecting-paypal">Configuring Your Commissions-->
                  <!--                      <i class="fas fa-angle-right"></i>-->
                  <!--                    </router-link>-->
                  <!--                  </li>-->

                  <li class="tutorials__item">
                    <router-link to="/help/connecting-paypal">Connecting to PayPal
                      <i class="fas fa-angle-right"></i></router-link>
                  </li>

                  <li class="tutorials__item">
                    <router-link to="/help/connecting-accounts-to-vendors">Setting up Vendor Portal
                      Accounts <i class="fas fa-angle-right"></i></router-link>
                  </li>

                  <!--                  <li class="tutorials__item">-->
                  <!--                    <router-link to="/help/connecting-paypal">Making Payouts to Your Vendors-->
                  <!--                      <i class="fas fa-angle-right"></i>-->
                  <!--                    </router-link>-->
                  <!--                  </li>-->

                  <!--                  <li class="tutorials__item">-->
                  <!--                    <router-link to="/help/connecting-paypal">Giving Your Vendors Access to Their-->
                  <!--                      Dashboard <i class="fas fa-angle-right"></i>-->
                  <!--                    </router-link>-->
                  <!--                  </li>-->

                  <!--                  <li class="tutorials__item">-->
                  <!--                    <router-link to="/help/connecting-paypal">Overriding Commissions-->
                  <!--                      <i class="fas fa-angle-right"></i></router-link>-->
                  <!--                  </li>-->
                </ul>
              </div>
            </div>
          </div>

          <div class="cell auto">
            <div class="panel">
              <div class="panel__header">
                <h2 class="panel__title">FAQ</h2>
              </div>

              <ul class="faqs">
                <li class="faqs__item">
                  <h3 class="faqs__item__title">How do I remove a vendor?</h3>

                  <div class="faqs__item__content">
                    <p>You can hide vendors from your account by selecting the vendor in the vendor
                      list then proceeding to their settings tab. In the commission details panel
                      you will see a checkbox labeled "hidden". Simply check that and save. The
                      vendor will no longer show in the vendor list or be calculated in total
                      commission values.</p>
                  </div>
                </li>

                <li class="faqs__item">
                  <h3 class="faqs__item__title">Why is my vendor not showing up?</h3>

                  <div class="faqs__item__content">
                    <p>Our system relies on Shopify to communicate data to the app. If a vendor is
                      not showing up please try one of the following:</p>

                    <ol>
                      <li>Verify that vendor name or tag is properly on the product(s) in Shopify.
                      </li>
                      <li>Run a data re-sync from the app settings.</li>
                    </ol>

                    <p>If your vendor(s) are still not showing up, please send us an email or
                      connect with us through our live chat service.</p>
                  </div>
                </li>

                <li class="faqs__item">
                  <h3 class="faqs__item__title">Why are my commissions not calculating
                    correctly?</h3>

                  <div class="faqs__item__content">
                    <p>Commissions can be calculated off of many various
                      settings. If you are finding your commissions are not
                      accurate please check your commission settings. If they
                      are still not calculating accurately please do not hesitate
                      to reach out to our support to assist you.</p>
                  </div>
                </li>

                <li class="faqs__item">
                  <h3 class="faqs__item__title">I have connected PayPal, but my
                    payments are not going through.</h3>

                  <div class="faqs__item__content">
                    <p>Below are the most common causes of payments not going
                      through:</p>

                    <ol>
                      <li>Your live PayPal api key and secret are invalid.</li>
                      <li>You have sandbox mode enabled in your PayPal settings
                        of our app. To submit real payments this will need to be
                        disabled.
                      </li>
                      <li>Your PayPal account is not enabled to send payouts.
                        Please refer to our PayPal tutorial
                        <router-link to="/help/connecting-paypal">
                          here
                        </router-link>
                        .
                      </li>
                    </ol>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: 'helpDashboard',
  components: {},
  mounted () {
    // let externalScript = document.createElement('script')
    // externalScript.setAttribute('src', 'https://desk.zoho.com/portal/api/feedbackwidget/680199000000184304?orgId=767537906&displayType=iframe')
    // document.head.appendChild(externalScript)
  }
}
</script>

<style lang="scss">
@import '../../styles/variables';
@import '../../styles/mixins';

.tutorials {
  margin: 0;
  list-style: none;
  width: 100%;

  &__item {
    margin-bottom: 10px;

    a {
      @include transition(background .2s);
      background: $darker-gray;
      border-radius: 3px;
      color: $hightlight-color;
      display: block;
      font-size: 17px;
      padding: 15px 50px 15px 15px;
      position: relative;

      svg {
        @include transform(translateY(-50%));
        color: $white;
        font-size: 30px;
        position: absolute;
        right: 20px;
        top: 50%;
      }

      &:hover {
        background: darken($darker-gray, 2.5%);
      }
    }
  }
}

.faqs {
  margin: 0;
  list-style: none;

  &__item {
    border-bottom: 1px solid $dark2-gray;
    margin-bottom: 30px;
    padding-bottom: 15px;

    &__title {
      color: $primary-color;
      font-size: 20px;
    }

    &__content {
      padding-left: 15px;

      ul,
      ol {
        margin-bottom: 1rem;
      }
    }

    &:last-child {
      border-bottom: 0;
      margin-bottom: 0;
      padding-bottom: 0;
    }
  }
}

.light-theme {
  .tutorials {
    &__item {
      a {
        background: $lighter-gray;
        color: #007ace;

        svg {
          color: $darkest-gray;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/help/dashboard.vue